export const createArray = (num: number): Array<number> => {
  return Array.from(Array(num).keys());
};
